import { render, staticRenderFns } from "./editConfigurationBlocked.vue?vue&type=template&id=a383b51a&lang=pug"
import script from "./editConfigurationBlocked.vue?vue&type=script&lang=js"
export * from "./editConfigurationBlocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports